import { format } from 'date-fns';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import ScorecardUserCard from './ScorecardUserCard';

const TOTAL_COLUMNS = 10;

export default function WeekSection({
  periodKey,
  weekLabel,
  weekStart,
  weekEnd,
  users,
  surveyQuestions,
  onIssueClick,
}) {
  let weekNum = null;
  let dateRange = null;

  if (!periodKey) {
    weekNum = 'Not Submitted';
  } else {
    weekNum = `Week ${periodKey.split('-')[1]}`;
    dateRange =
      weekStart && weekEnd
        ? `${format(new Date(weekStart), 'dd MMM')} – ${format(new Date(weekEnd), 'dd MMM yyyy')}`
        : weekLabel;
  }

  return (
    <>
      {/* Week separator row */}
      <TableRow>
        <TableCell
          colSpan={TOTAL_COLUMNS}
          sx={{
            py: 0,
            px: 0,
            borderTop: '2px solid',
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            position: 'sticky',
            top: 41,
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 1.5,
              py: 0.6,
              borderLeft: '3px solid',
              borderColor: 'primary.main',
            }}
          >
            <Typography variant="caption" fontWeight={700} color="text.primary" sx={{ letterSpacing: '0.02em' }}>
              {weekNum}
            </Typography>
            {dateRange && (
              <Typography variant="caption" color="text.secondary">
                {dateRange}
              </Typography>
            )}
          </Box>
        </TableCell>
      </TableRow>

      {/* User rows */}
      {users.map((user) => (
        <ScorecardUserCard
          key={user.userId}
          user={user}
          surveyQuestions={surveyQuestions}
          onIssueClick={onIssueClick}
        />
      ))}
    </>
  );
}
